module.exports = __webpack_public_path__ + "media/images/camera-small-f122a5552d4bf9c5fe3dc4c1ff44022b.png";